// extracted by mini-css-extract-plugin
var _1 = "M_BxGBrG5sHNlHRs4Or_";
var _2 = "i7qQAXI73iYQjbI2gGoB";
export { _1 as "sectionGroup", _2 as "sectionGroupHeading" }
